export default __webpack_public_path__ + "static/media/picture-02.fc45ba90.svg";